// extracted by mini-css-extract-plugin
export default {"EditionStyle":"EditionAreaWidget_EditionStyle__uUyQX"};